import { PropsWithChildren, useId } from 'react';

import styles from './list.module.css';

type ListProps = PropsWithChildren<{
  title?: string;
}>;
export const List = ({ title, children }: ListProps) => {
  const labelId = useId();

  return (
    <div className={styles.wrapper}>
      {title && (
        <div id={labelId} className={styles.listTitle}>
          {title}
        </div>
      )}

      <ul className={styles.list} aria-labelledby={title ? labelId : undefined}>
        {children}
      </ul>
    </div>
  );
};
